import { AnyAction } from '@reduxjs/toolkit'
import { findIndex, has } from 'lodash'

import {
  FETCH_ACTIVE_NOW_SUCCESS,
  FETCH_CHAT_ACTIVITY_SUCCESS,
  FETCH_CONNECTOR_ACTIVITY_SUCCESS,
  FETCH_SPACE_ENGAGEMENT_ANALYTICS_SUCCESS,
  FETCH_SYSTEM_CONNECTOR_ACTIVITY_SUCCESS
} from './actionTypes'

type SpaceAnalyticsPageState = {
  userActivity: any[]
  engagementOverTime: any[]
  deviceMetrics: any[]
  connectorActivity: any[]
  totalActiveUsers: number
  totalEngagedUsers: number
  totalActivity: number
  totalEngagements: number
  totalEngagedNow: number
  totalSpaceMembers: number
  chatMetrics: unknown
  publisherMetrics: unknown
  previousTotalActiveUsers?: unknown
  previousTotalEngagedUsers?: unknown
  previousTotalActivity?: unknown
  previousTotalSpaceMembers?: unknown
  previousChatMetrics?: unknown
  previousPublisherMetrics?: unknown
  previousTotalEngagements?: unknown
}

const initialState: SpaceAnalyticsPageState = {
  userActivity: [],
  engagementOverTime: [],
  deviceMetrics: [],
  connectorActivity: [],
  totalActiveUsers: 0,
  totalEngagedUsers: 0,
  totalActivity: 0,
  totalEngagements: 0,
  totalEngagedNow: 0,
  totalSpaceMembers: 0,
  chatMetrics: {},
  publisherMetrics: {}
}

const PUBLISHER_CONNECTOR = 'Publisher API Connector'

export default (state = initialState, action: AnyAction): SpaceAnalyticsPageState => {
  switch (action.type) {
    case FETCH_ACTIVE_NOW_SUCCESS: {
      return {
        ...state,
        totalEngagedNow: action.response.engagedNow
      }
    }

    case FETCH_CONNECTOR_ACTIVITY_SUCCESS: {
      return {
        ...state,
        connectorActivity: has(action.response, 'requestedPeriod')
          ? [...action.response.requestedPeriod]
          : [...action.response]
      }
    }

    case FETCH_CHAT_ACTIVITY_SUCCESS: {
      return {
        ...state,
        userActivity: [...action.response.requestedPeriod.chatActivityOverTime],
        totalActivity: action.response.requestedPeriod.sessions,
        previousTotalActivity: has(action.response, 'previousPeriod')
          ? action.response.previousPeriod.sessions
          : undefined,
        chatMetrics: {
          members: action.response.requestedPeriod.members,
          sessions: action.response.requestedPeriod.sessions,
          messages: action.response.requestedPeriod.messages
        },
        previousChatMetrics: has(action.response, 'previousPeriod')
          ? {
              members: action.response.previousPeriod.members,
              sessions: action.response.previousPeriod.sessions,
              messages: action.response.previousPeriod.messages
            }
          : undefined
      }
    }

    case FETCH_SYSTEM_CONNECTOR_ACTIVITY_SUCCESS: {
      return {
        ...state,
        publisherMetrics:
          action.response.requestedPeriod[
            findIndex(action.response.requestedPeriod, { connectorName: PUBLISHER_CONNECTOR })
          ],
        previousPublisherMetrics: has(action.response, 'previousPeriod')
          ? action.response.previousPeriod[
              findIndex(action.response.requestedPeriod, { connectorName: PUBLISHER_CONNECTOR })
            ]
          : undefined
      }
    }

    case FETCH_SPACE_ENGAGEMENT_ANALYTICS_SUCCESS: {
      return {
        ...state,
        engagementOverTime: [...action.response.requestedPeriod.engagementsOverTime],
        totalEngagements: action.response.requestedPeriod.totalEngagements,
        totalEngagedUsers: action.response.requestedPeriod.totalEngagedUsers,
        previousTotalEngagements: has(action.response, 'previousPeriod')
          ? action.response.previousPeriod.totalEngagements
          : undefined,
        previousTotalEngagedUsers: has(action.response, 'previousPeriod')
          ? action.response.previousPeriod.totalEngagedUsers
          : undefined,
        deviceMetrics: [...action.response.requestedPeriod.engagementsByDevice],
        totalSpaceMembers: action.response.requestedPeriod.totalSpaceMembers,
        previousTotalSpaceMembers: has(action.response, 'previousPeriod')
          ? action.response.previousPeriod.totalSpaceMembers
          : undefined
      }
    }

    default: {
      return state
    }
  }
}
